import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {ProductRecommendation} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/recommendation_sections.types';
import {MovSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/service.types';
import {
  useTrackFeature,
  useTrackFeatureInViewImpression,
} from '@aboutyou/tracking';
import {ContentPopperProps} from '@aboutyou/ui-components';
import React, {RefObject, useEffect} from 'react';
import {FreeDeliverySectionView} from '../../../features/FreeDeliverySectionView/FreeDeliverySectionView';
import {AddToBasketOnSuccessProps} from '../../../features/SizeSelectionFlyout/hooks/useAddToBasket';

type RefetchBasketSectionType = () => Promise<void>;

export interface RecommendationsComponentProps {
  movUpsellingRecommendationSection: ProductRecommendation;
  onAddToBasketSuccess?: (props: AddToBasketOnSuccessProps) => void;
  refetchBasketSection: RefetchBasketSectionType;
}
export interface BasketMOVProps {
  className?: string;
  ProgressMoreInfoLayoutComponent: ContentPopperProps['LayoutComponent'];
  padded?: boolean;
  RecommendationsComponent?: React.FC<RecommendationsComponentProps>;
  onAddToBasketSuccess?: (props: AddToBasketOnSuccessProps) => void;
  refetchBasketSection: RefetchBasketSectionType;
  isMovReached?: boolean;
}

export const BasketMOVView: React.FC<BasketMOVProps & MovSection> = ({
  className,
  ProgressMoreInfoLayoutComponent,
  movUpsellingRecommendationSection,
  RecommendationsComponent,
  padded,
  onAddToBasketSuccess,
  freeDeliverySection,
  refetchBasketSection,
  isMovReached,
}) => {
  const trackFeature = useTrackFeature();

  const {isActive} = useIsFeatureActive('minimal_order_value');

  const {isActive: showRecos, activateAbTest} = useIsFeatureActive(
    'mov_upselling_recos',
  );

  const {ref: hint} = useTrackFeatureInViewImpression(
    {label: 'mov_info'},
    {triggerOnce: true},
  );

  const handleMoreInfoIconClick = () => {
    trackFeature({eventType: 'click', label: 'MOV_basket_info_hint'});
  };

  useEffect(() => {
    if (freeDeliverySection && isActive) {
      activateAbTest();
    }
  }, [freeDeliverySection, activateAbTest, isActive]);

  if (!freeDeliverySection || !isActive) {
    return null;
  }

  return (
    <div className={className}>
      <FreeDeliverySectionView
        ref={hint as RefObject<HTMLDivElement | null>}
        freeDeliverySection={freeDeliverySection}
        ProgressMoreInfoLayoutComponent={ProgressMoreInfoLayoutComponent}
        padded={padded}
        showSubtitleAboveProgressBar={showRecos}
        onMoreInfoIconClick={handleMoreInfoIconClick}
        isMovReached={isMovReached}
      />
      {RecommendationsComponent &&
        showRecos &&
        movUpsellingRecommendationSection && (
          <RecommendationsComponent
            movUpsellingRecommendationSection={
              movUpsellingRecommendationSection
            }
            onAddToBasketSuccess={onAddToBasketSuccess}
            refetchBasketSection={refetchBasketSection}
          />
        )}
    </div>
  );
};
